import React from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'
import { Helmet } from 'react-helmet'
import store, { persistor } from './store'
import Theme from 'components/template/Theme'
import Layout from 'components/layout'
import SupabaseSessionBridge from 'components/SupabaseSessionBridge'
import history from './history'
import mockServer from './mock'
import appConfig from 'configs/app.config'
import './locales'
import { Analytics } from '@vercel/analytics/react';

const environment = process.env.NODE_ENV

/**
 * Set enableMock(Default false) to true at configs/app.config.js
 * If you wish to enable mock api
 */
if (environment !== 'production' && appConfig.enableMock) {
    mockServer({ environment })
}

function App() {
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <BrowserRouter history={history}>
                    <Helmet>
                            <title>Backups.so - Automated Notion Backups</title>
                            <script defer src="https://u.nerdysherpas.com/script.js" data-website-id="3be3276b-0212-4f4f-a3d4-7815903e023c"></script>
                    </Helmet>
                    <Theme>
                        <SupabaseSessionBridge />
                        <Layout />
                        <Analytics />
                    </Theme>
                </BrowserRouter>
            </PersistGate>
        </Provider>
    )
}

export default App
